import { useEffect } from 'react';
import { DEFAULT_START_YEAR } from "../../utils/date";
export var useYearsScroll = function useYearsScroll(_ref) {
  var containerRef = _ref.containerRef,
    currentVisibleDate = _ref.currentVisibleDate,
    isActive = _ref.isActive,
    refs = _ref.refs;
  var scrollToYear = function scrollToYear() {
    var _containerRef$current, _refs$index, _refs$index$current;
    var index = currentVisibleDate.getFullYear() - DEFAULT_START_YEAR;
    var height = ((_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.offsetHeight) || 0;
    (_refs$index = refs[index]) === null || _refs$index === void 0 ? void 0 : (_refs$index$current = _refs$index.current) === null || _refs$index$current === void 0 ? void 0 : _refs$index$current.focus();
    if (height !== 0 && containerRef.current) {
      var itemHeight = (height - 12) / 4;
      containerRef.current.scrollTo({
        top: itemHeight * (Math.ceil(index / 4) - 1)
      });
    }
  };
  useEffect(function () {
    if (isActive) {
      setTimeout(scrollToYear, 0);
    }
  }, [currentVisibleDate, isActive]);
};